<template>
    <div>
      <banner/>
      <search-container :addAlias="false"/>
    </div>
</template>

<script>
import banner from '@/components/Banner';
import searchContainer from '@/components/SearchContainer';

export default {
  name: 'Home',
  props: {
    "query": String
  },

  components: {
    banner,
    searchContainer,
  },
};
</script>
